var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.535 1.465L7.83 2.17C8.55 2.895 9 3.895 9 5C9 7.21 7.21 9 5 9C2.79 9 1 7.21 1 5C1 2.96 2.525 1.28 4.5 1.035V2.045C3.08 2.285 2 3.515 2 5C2 6.655 3.345 8 5 8C6.655 8 8 6.655 8 5C8 4.17 7.665 3.42 7.12 2.88L6.415 3.585C6.775 3.95 7 4.45 7 5C7 6.105 6.105 7 5 7C3.895 7 3 6.105 3 5C3 4.07 3.64 3.295 4.5 3.07V4.14C4.2 4.315 4 4.63 4 5C4 5.55 4.45 6 5 6C5.55 6 6 5.55 6 5C6 4.63 5.8 4.31 5.5 4.14V0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 3.62 9.44 2.37 8.535 1.465Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.aab7b9ed31663fd253124fbc92217dfe.svg";
export { ForwardRef as ReactComponent };